import { Logger } from "../../helpers/Logger";
import { getTrackingId } from "../config/CONSTANTS";

/**
 * Handles tracking events with Reddit Pixel.
 *
 * @example
 * trackRedditPixelEvent('PageView', { page_path: '/home' });
 * trackRedditPixelEvent('view-content', { content_name: 'Product Page' }); // Maps to 'PageView' or 'ViewContent'
 *
 * @param {string} eventType - The type of event to track.
 * @param {Object} eventData - The data to send with the event.
 */
export function trackRedditPixelEvent(eventType, eventData) {
    // Define a mapping for event names to the expected ones for the platform
    const eventMapping = {
        'View-Content': 'ViewContent',
        'PageView': 'PageVisit',
        'Contact': 'Lead', // Contact Us Form
        'FindLocation': 'Search', // View Store Locator Page
        'Subscribe': 'SignUp', // Newsletter
        'ViewContent': 'ViewContent',
    };

    // Map the eventType to a standard event name if it exists in the mapping above, otherwise use the original
    const mappedEventType = eventMapping[eventType] || eventType;

    // Check if the pixel script is already loaded
    function initPixel() {
        if (typeof window.rdt === 'function') return;

        try {
            // Reddit Init Script
            !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);
            rdt('init', getTrackingId("Reddit_Pixel"));
        } catch (error) {
            Logger.error("Error initializing Reddit Pixel:", error);
        }
    }
    // TODO - Honestly, this could pobably be inline but the original developer had it as a separate function.
    initPixel();

    // Transform eventData to match Reddit Pixel's expected format
    const redditPayload = {
        conversionId: eventData.eventId,
    };

    if ( typeof window.rdt === 'function' ) {
        // Send the event to Reddit Pixel
        window.rdt("track", mappedEventType, redditPayload);
        Logger.log(`Reddit Pixel event sent: ${mappedEventType}`, redditPayload);
    } else {
        Logger.error("Reddit Pixel not loaded, initialization failed or script not included.");
    }
}